module.exports = __webpack_public_path__ + "img/1.65cf93f3.png";